import React,{Component} from 'react';
import { Container, Alert} from 'reactstrap';
import {apiClient} from '../../axios/apiClient';
class NewsLetter extends Component{
    constructor(props){
        super(props);
        this.state={
            email:'',
            error: '',
            loader: false,
            ApiMessage:''
        }
    }

    onDismiss = (e) => {
        this.setState({ loader: false });
    }

    handleInputValidation=(data)=>{
        let error={};
        let emailRegex=/^(([A-Za-z0-9]+_+)|([A-Za-z0-9]+\-+)|([A-Za-z0-9]+\.+)|([A-Za-z0-9]+\++))*[A-Za-z0-9]+@((\w+\-+)|(\w+\.))*\w{1,63}\.[a-zA-Z]{2,6}$/;
        if(!data.email || data.email==="") error.email="Please enter your email address";
        if(!emailRegex.test(data.email)) error.email= "Invalid email format";
        return error;

    }

    onInputChange=(e)=>{
        this.setState({
            [e.target.name]:e.target.value
        })
    }

    handleSubmit = (e) =>{
        e.preventDefault();
        let error={...this.state.error};
        error=this.handleInputValidation(this.state);
        this.setState({error},()=>{
            if (Object.keys(error).length <= 0) {
                apiClient.post("/api/Subscription/AddEmail?EmailId=" + this.state.email).then(res => {
                    if (res.data.succeeded === true) {
                        this.setState({
                            loader: true,
                            ApiMessage: 'You have successfully subscribed to our newsletter.'
                        });
                    }
                    else {
                        this.setState({
                            loader: true,
                            ApiMessage: 'Sorry, an error has occurred.'
                        });
                    }
                    this.setState({
                        email: ''
                    });
                });
                
            }else{
                // alert("error");
            }
        });

    }
    render(){
        return(
            <div className="item">
                <h2>Subscribe</h2>
                <p>Get the latest news and information from us.</p>
                <form onSubmit={this.handleSubmit}>
                    <div className={`input-group ${this.state.error.email?'error':''}`}>
                        <input className="form-control" name="email" onChange={this.onInputChange} placeholder="Email address" value={this.state.email}/>
                        <div className="input-group-addon">
                            <i className="icon-envelope"></i>
                        </div>  
                        
                    </div>
                    {this.state.error.email && <p className="error">{this.state.error.email}</p>}
                    <div className="form-group">
                        <button type="submit" className="btn btn-primary">Subscribe</button>
                    </div>
                    <Alert isOpen={this.state.loader} toggle={this.onDismiss}>
                        {this.state.ApiMessage}
                    </Alert>
                </form>
            </div>
        );
    }
 
}


export default NewsLetter;
